import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { routes } from './route-config';

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'disabled',
      initialNavigation: 'disabled',
    }),
  ],
})
export class AppRoutingModule {}
